import client from '../client/client'

// Howie hint cards prompt (KAZ-3991): the instructions Gemini uses for the 4 suggestion cards of a new chat.
// GET returns data.data = {key, name, version, updated_at, updated_by, assembly, sections, fallback_cards}
const getHintCardsPromptRequest = async () => {
  const {data} = await client.get('api/admin/v1/hint-cards')
  return data.data
}

// PUT api/admin/v1/hint-cards/{id} (id from the GET)
// data: {base_version, sections: [{key, text}] (editable ones only), fallback_cards: [{label, request}] x4}
const updateHintCardsPromptRequest = async (data: HintCardsPromptUpdate, id: number | string) => {
  try {
    return await client.put(`api/admin/v1/hint-cards/${id}`, data)
  } catch (error) {
    return error
  }
}

export type HintCard = {label: string; request: string}

export type HintCardsPromptUpdate = {
  base_version: number
  sections: {key: string; text: string}[]
  fallback_cards: HintCard[]
}

export {getHintCardsPromptRequest, updateHintCardsPromptRequest}
